<template>
  <div class="change-answer-effect">
    <el-tooltip
      :disabled="!selectedContent"
      :visible-arrow="false"
      :content="selectedContent"
      placement="top"
    >
      <el-select
        id="question-select"
        v-close-on-zoom
        :value="state.effect.id"
        :placeholder="placeholder"
        :filterable="true"
        :default-first-option="true"
        class="question-select"
        :disabled="readonly"
        @input="(questionId) => selectQuestion(questionId)"
      >
        <el-option
          v-for="question in getDialogueItems(emitter.caseConf)"
          :key="question.id"
          :label="question.content.en"
          :value="question.id"
        />
      </el-select>
    </el-tooltip>

    <help-tooltip v-if="questionErrors.length" type="error">
      <span v-for="error in questionErrors" :key="error.message">{{
        error.message
      }}</span>
    </help-tooltip>
    <div>
      <el-input
        v-if="state.effect.id"
        id="answer-input"
        :value="state.effect.value"
        :placeholder="aiEnabled ? 'Response' : 'Answer'"
        :disabled="readonly || state.effect.response === 'AI'"
        class="answer-input"
        @input="(answer) => updateAnswer(answer.trim())"
      />
    </div>
    <el-card v-if="aiEnabled && state.effect.id" :body-style="{padding: '6px'}">
      <el-checkbox
        label="AI Response"
        :value="state.effect.response === 'AI'"
        :disabled="readonly"
        @input="v => updateAiResponse(v)"
      />
    </el-card>
    <div v-if="aiEnabled" class="reason-container">
      <el-input
        id="answer-reason"
        :value="state.effect.reason"
        placeholder="Reason for Response"
        :disabled="readonly"
        class="reason-input"
        @input="(reason) => updateReason(reason.trim())"
      />
      <help-tooltip v-if="missingReasonError" type="error" class="help-tooltip">
        {{ missingReasonError.message }}
      </help-tooltip>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

import HelpTooltip from '../../common/components/HelpTooltip';
import nodeMixins from './mixins/NodeMixins';

export default {
  name: 'change-answer-effect',
  components: {
    HelpTooltip,
  },
  mixins: [ nodeMixins ],
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'effectType',
    'placeholder',
    'getDialogueItems',
  ],
  data() {
    return {
      state: {
        effect: {},
      },
    };
  },
  computed: {
    selectedContent() {
      const items = this.getDialogueItems(this.emitter.caseConf) || [];
      const item = items.find(i => i.id === this.state.effect.id);
      return get(item, 'content.en');
    },
    questionErrors() {
      return (this.errors || []).filter(
        error => error.metadata.errorId === 'missingQuestion' || error.metadata.errorId === 'invalidQuestion'
      );
    },
    missingReasonError() {
      return (this.errors || []).find(error => error.metadata.errorId === 'missingReason');
    },
    aiEnabled() {
      return this.effectType === 'AI_ANSWER';
    },
  },
  mounted() {
    this.syncState();
    this.emitter.on('process', (nodeOrControl) => {
      // Update internal state when the node data changes
      // outside (e.g. from a CallAction)
      if (nodeOrControl === this.control) {
        this.syncState();
      }
    });
    this.update();
  },
  methods: {
    syncState() {
      this.state.effect = this.getData(this.ikey) || {};
    },
    selectQuestion(questionId) {
      this.state.effect.id = questionId;
      this.update();
    },
    updateAnswer(answer) {
      this.state.effect.value = answer;
      this.update();
    },
    updateAiResponse(value) {
      this.state.effect.response = value ? 'AI' : 'CUSTOM';
      if (value) {
        this.state.effect.value = '';
      }
      this.update();
    },
    updateReason(reason) {
      this.state.effect.reason = reason;
      this.update();
    },
    update() {
      this.putData(this.ikey, { type: this.effectType, ...this.state.effect });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.reason-container {
  display: flex;
  align-items: center;
}
</style>
